import React from 'react';
import { SubscribeCard } from '../Subscribe/components';
import { fontSizes } from '../../constants/constants';
import AvailableFundFunctional from './index.function.js';
import Text from '../../components/Text';
import Loader from '../../components/Loader';

const AvailableFunds = () => {
  const { TextWeight, getContentKey, fund_loading, funds, direction } = AvailableFundFunctional();

  return (
    <div>
      <Text
        text={getContentKey('heading')}
        size={fontSizes.h24}
        weight={TextWeight.bold}
        color='text-black'
      />

      {fund_loading ? (
        <div className='w-full mx-auto mt-10'>
          <Loader />
        </div>
      ) : (
        funds?.fundMaster?.length > 0 ? (
          <div dir={direction} className={'grid grid-cols-1 lg:grid-cols-2 gap-5 mt-4'}>
            {funds?.fundMaster?.map((item, i) => (
              <SubscribeCard item={item} key={i} />
            ))}
          </div>
        ) : (
          <Text
            text={getContentKey('no_available_fund_found')}
            size={fontSizes.h16}
            isCenter
            className={'mt-10'}
          />
        )
      )}
    </div>
  );
};

export default AvailableFunds;
